import { NoteCustomAttributes } from '../../sharedTypes/Api';
import samplesSelectorModel from '../../components/Samples/SamplesSelector/SamplesSelectorModel';
import { dpAssert } from '@/utils/helpers';
import { Note as note } from '@/sharedTypes/main';
import { ManagerEntity } from '@/shared/globalFunctions';
import { observable } from 'mobx';

class NotesCustomAttributesEditor {
  selectedNote: note | undefined;
  selectedNoteId: string | undefined;
  currNoteCustomAttributes: NoteCustomAttributes | undefined;
  noteCustomAttributes: NoteCustomAttributes[] = [];

  selectNote(noteVal: note) {
    this.selectedNote = noteVal;
    this.selectedNoteId = noteVal.noteId;
    const currentSample = samplesSelectorModel.selectedSample;
    dpAssert(currentSample && ManagerEntity.core);

    const existing = currentSample.notesCustomAttributes?.find(
      (n) =>
        n.measureIndex === this.selectedNote?.measureIndex &&
        n.indexInXmlParent === (this.selectedNote?.midi as any).indexInXmlParent
    );

    this.currNoteCustomAttributes = observable({
      indexInXmlParent: (this.selectedNote.midi as any).indexInXmlParent,
      measureIndex: this.selectedNote.measureIndex,
      hand: this.selectedNote.hand,
      xOffset: existing?.xOffset ?? 0,
    });
  }

  async addNoteCustomAttributeToCurrentSample() {
    const currentSample = samplesSelectorModel.selectedSample;
    dpAssert(currentSample && ManagerEntity.core);
    // send update with new hands etc... let's call it patch timemap
    if (!currentSample.notesCustomAttributes) {
      currentSample.notesCustomAttributes = [];
    }
    dpAssert(
      currentSample.notesCustomAttributes && this.currNoteCustomAttributes
    );
    // remove all elements with that measureIndex and that indexInXmlParent
    currentSample.notesCustomAttributes =
      currentSample.notesCustomAttributes.filter((n) => {
        return !(
          n.measureIndex === this.currNoteCustomAttributes?.measureIndex &&
          n.indexInXmlParent === this.currNoteCustomAttributes.indexInXmlParent
        );
      });
    // push new
    currentSample.notesCustomAttributes.push(this.currNoteCustomAttributes);
  }
  setXOffset(offset: number) {
    if (this.currNoteCustomAttributes && this.selectedNoteId) {
      this.currNoteCustomAttributes.xOffset =
        typeof offset === 'number' ? offset : 0;

      const noteEl = document.getElementById(this.selectedNoteId);

      if (noteEl) {
        // Define the transformation you want to apply
        const transformValue = `translate(${this.currNoteCustomAttributes.xOffset}, 0)`;

        // Set the transform attribute
        noteEl.setAttribute('transform', transformValue);
      }
    }
  }
  async resetVariables() {
    this.noteCustomAttributes.length = 0;
  }
}

export default NotesCustomAttributesEditor;
